import { TeamsTheme } from "../../themes";
/**
 * The illustration, text, and actions (if any) to use by default as the content of this component.
 * @public
 */
export var CommunicationOptions;
(function (CommunicationOptions) {
    CommunicationOptions["Default"] = "default";
    CommunicationOptions["Welcome"] = "welcome";
    CommunicationOptions["Hello"] = "hello";
    CommunicationOptions["Empty"] = "empty";
    CommunicationOptions["Error"] = "error";
    CommunicationOptions["Thanks"] = "thanks";
})(CommunicationOptions || (CommunicationOptions = {}));
//# sourceMappingURL=CommunicationTypes.js.map